import React, { useState, useEffect } from "react";
import { Box, TextField, Chip, Stack, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const TagInput = ({ label, value, onChange, error, helperText }) => {
  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState([]);
  const muiTagColors = [
    { bg: "#DBEAFE", text: "#1E40AF" }, // blue
    { bg: "#DCFCE7", text: "#166534" }, // green
    { bg: "#F3E8FF", text: "#6B21A8" }, // purple
    { bg: "#FFEDD5", text: "#9A3412" }, // orange
  ];


  useEffect(() => {
    if (value) {
      setTags(
        value
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean)
      );
    } else {
      setTags([]);
    }
  }, [value]);

  const addTag = () => {
    const trimmed = inputValue.trim();
    if (!trimmed || tags.includes(trimmed)) return;

    const newTags = [...tags, trimmed];
    setTags(newTags);
    onChange(newTags.join(","));
    setInputValue("");
  };

  const removeTag = (tagToDelete) => {
    const newTags = tags.filter((tag) => tag !== tagToDelete);
    setTags(newTags);
    onChange(newTags.join(","));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <Box>
      <div className="flex items-center gap-2 mb-2">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={helperText}
          className="
            h-[55px]
            flex-1
            rounded-md
            px-3
            py-2
            border
            border-[rgba(0,0,160,0.2)]
            placeholder-gray-500
            transition
            duration-200

            hover:border-[rgba(0,0,160,0.5)]

            focus:outline-none
            focus:border-[#FF03F3]
            focus:ring-2
            focus:ring-[#FF03F3]
            "
        />

        <button
          type="button"
          onClick={() => addTag()}
          className="px-4 py-2 h-[55px] bg-[#FF03F3] text-white rounded-md hover:bg-[#000080] disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Add
        </button>
      </div>

      {tags.length > 0 && (
        <Stack direction="row" spacing={1} mt={1} flexWrap="wrap">
          {tags.map((tag, index) => {
            const color = muiTagColors[index % muiTagColors.length];

            return (
              <Chip
                key={tag}
                label={tag}
                onDelete={() => removeTag(tag)}
                sx={{
                  mb: 1,
                  backgroundColor: color.bg,
                  color: color.text,
                  fontWeight: 500,
                  "& .MuiChip-deleteIcon": {
                    color: color.text,
                    "&:hover": {
                      color: "#000080",
                    },
                  },
                }}
              />
            );
          })}
        </Stack>
      )}

    </Box>
  );
};

export default TagInput;
